import * as Sentry from '@sentry/browser'

export function reportGetStreamError(
  error: unknown,
  operation: string,
  extraContext: Record<string, unknown> = {}
) {
  console.error(`[GetStream] ${operation} failed`, error)

  Sentry.withScope((scope) => {
    scope.setTag('integration', 'getstream')
    scope.setTag('getstream.operation', operation)
    scope.setContext('getstream', {
      operation,
      ...extraContext
    })
    Sentry.captureException(error)
  })
}

export async function feedGetWithRetry(
  feed: { get: (params: Record<string, unknown>) => Promise<unknown> },
  params: Record<string, unknown>,
  operation: string
) {
  try {
    return await feed.get(params)
  } catch (firstError) {
    try {
      return await feed.get(params)
    } catch (retryError) {
      reportGetStreamError(retryError, operation, { retried: true })
      throw retryError
    }
  }
}
